const profile = {
  name: 'Parvin Malekzadeh',
  // title: 'Postdoctoral Fellow, Rotman School of Management, University of Toronto',
  about: `<p>Hi! I'm a Postdoctoral Fellow in Operations Management & Statistics at the Rotman School of Management, University of Toronto, supervised by <a href="https://discover.research.utoronto.ca/10004" target="_blank">Prof. Opher Baron</a> and <a href="https://discover.research.utoronto.ca/7243-dmitry-krass" target="_blank">Prof. Dmitry Krass</a>.</p>
  <p>I'm also a Part-Time Instructor at the Schulich School of Business, York University.</p>
  <p>My research focuses on data-driven stochastic decision-making, combining reinforcement learning, queueing systems, and process simulation and digital twins to improve operational systems, particularly healthcare operations such as emergency department patient flow. I'm passionate about advancing autonomous AI to support real‑world decision‑making.</p>
  <p>Prior to this, I earned my Ph.D. in the Edward S. Rogers Sr. Department of Electrical & Computer Engineering at the University of Toronto, under the supervision of <a href="https://www.dsp.utoronto.ca/~kostas/" target="_blank">Prof. Kostas Plataniotis</a>, with a thesis on advancing efficiency and safety in autonomous sequential decision-making agents.</p>`,
  profileImage: process.env.PUBLIC_URL + '/images/parvin.png',
  cvUrl: process.env.PUBLIC_URL + '/assets/CV/Parvin_Malekzadeh_CV.pdf',
  email: 'p.malekzadeh@rotman.utoronto.ca',
  social: [
    { icon: 'github', url: 'https://github.com/pmalekzadeh' },
    { icon: 'linkedin', url: 'http://www.linkedin.com/in/parvin-malekzadeh-b1364014a' },
    { icon: 'email', url: 'mailto:p.malekzadeh@rotman.utoronto.ca' },
    { icon: 'scholar', url: 'https://scholar.google.com/citations?hl=en&user=zHoFtSIAAAAJ' },
  ],
  skills: [
    'Data-Driven Stochastic Decision-Making', 'Reinforcement Learning', 'Queueing Systems', 'Healthcare Operations',
    'Process Simulation and Digital Twins', 'Deep Learning', 'LLM', 'Uncertainty-Aware Decision Making', 'Optimization', 'Statistics'
  ],
  awards: [
    {
      title: "Management Data and Analytics Lab Research Grant ($3,000)",
      organization: "University of Toronto",
      year: "2025-2026",
      category: "Academic Excellence",
      description: ""
    },
    {
      title: "Nominated for the Best Ph.D. Dissertation Award",
      organization: "University of Toronto",
      year: "2024",
      category: "Academic Excellence",
      description: "Recognized for outstanding doctoral research in Electrical and Computer Engineering."
    },
    // {
    //   title: "Best Master's Thesis Award",
    //   organization: "Concordia University",
    //   year: "2020",
    //   category: "Research Excellence",
    //   description: "Awarded $10,000 for exceptional master's thesis research."
    // },
    {
      title: "Graduate Entrance Award",
      organization: "Concordia University",
      year: "2018",
      category: "Academic Excellence",
      description: "Received $5,000 for outstanding academic achievements upon graduate program admission."
    },
    {
      title: "Iran's National Elites Foundation (INEF) Grant",
      organization: "Iran",
      year: "2013-2017",
      category: "Academic Excellence",
    },
    {
      title: "National University Entrance Exam in Mathematics Achievement",
      organization: "Iran",
      year: "2013",
      category: "Academic Excellence",
      description: "Ranked 1st among more than 50,000 participants in the National University Entrance Exam in Mathematics (Konkour)."
    },
    {
      title: "Iran National Mathematics Olympiad",
      organization: "Iran",
      year: "2012",
      category: "Academic Competition",
      description: "Achieved semi-finalist status in the national mathematics competition."
    }
  ],
  research: 
  [
    {
      title: "Sample-Augmented Reinforcement Learning for Event-Driven Queueing Control",
      authors: "O. Baron, S. He, D. Krass, P. Malekzadeh, A. Senderovich, and H. Yuan (Prepared for submission, 2026)",
    },
    {
      title: "Shift Effect in Physician Effort Allocation in Emergency Departments with Patient Abandonment",
      authors: "O. Baron, S. He, D. Krass, P. Malekzadeh, and H. Yuan (Prepared for submission, 2026)",
    }
  ],

  underReview: [
    {
      title: "Shift Effects in the Emergency Department: Threshold Routing and Tail Access Performance",
      authors: "O. Baron, S. He, D. Krass, P. Malekzadeh, and H. Yuan",
      venue: "Under review at Operations Research, 2026"
    },
    {
      title: "Bayesian Adversarial Distributional Reinforcement Learning for Sample-Efficient Risk-Sensitive Control",
      authors: "P. Malekzadeh, K. N. Plataniotis, and M. Sheikholeslami",
      venue: "Under review at ICLR 2027"
    }
  ],
  
  publications: [
    {
      title: "A Unified Particle Filter LSTM for Data-Driven Process Simulation",
      authors: "P Malekzadeh, O Baron, D Krass",
      venue: "INFORMS Workshop on Data Science, 2026",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2609.01967" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/UnifiedPF-LSTM/index.html" }
      ]
    },
    {
      title: "Active Inference and Reinforcement Learning: A Unified Inference on Continuous State and Action Spaces under Partial Observability",
      authors: "P Malekzadeh, KN Plataniotis",
      venue: "Neural Computation, 2024",
      image: process.env.PUBLIC_URL + "/images/Inference.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2212.07946.pdf" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/UnifiedInference/index.html" }
      ]
    },
    {
      title: "EX-DRL: Hedging Against Heavy Losses with EXtreme Distributional Reinforcement Learning",
      authors: "P Malekzadeh, Z Poulos, J Chen, Z Wang, KN Plataniotis",
      venue: "Proceedings of the 5th ACM International Conference on AI in Finance, 2024",
      image: process.env.PUBLIC_URL + "/images/EX-DRL.png",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2408.12446" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/EX-DRL/index.html" },
        { label: "code", url: "https://github.com/pmalekzadeh/EX-DRL" }
      ]
    },
    {
      title: "UaMB-SF: Uncertainty-aware transfer across tasks using hybrid Model-Based Successor Feature reinforcement learning",
      authors: "P Malekzadeh, M Hou, KN Plataniotis",
      venue: "Neurocomputing, 2023",
      image: process.env.PUBLIC_URL + "/images/SF-MB2.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2310.10818.pdf" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/UaMB-SF/index.html" }
      ]
    },
    {
      title: "A Robust Quantile Huber Loss with Interpretable Parameter Adjustment in Distributional Reinforcement Learning",
      authors: "P Malekzadeh, KN Plataniotis, Z Poulos, Z Wang",
      venue: "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), 2024",
      image: process.env.PUBLIC_URL + "/images/loss.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2401.02325.pdf" },
        { label: "code", url: "https://github.com/pmalekzadeh/A-robust-quantile-huber-loss" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/RobusLossFunction/index.html" }
      ]
    },
    {
      title: "AKF-SR: Adaptive Kalman filtering-based Successor Representation",
      authors: "P Malekzadeh, M Salimibeni, M Hou, A Mohammadi, KN Plataniotis",
      venue: "Neurocomputing, 2022",
      image: process.env.PUBLIC_URL + "/images/AKF-SR2.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2204.00049.pdf" },
        { label: "code", url: "https://github.com/pmalekzadeh/AKF-SR" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/AKF-SR/index.html" }
      ]
    },
    {
      title: "UUaE: A Unified Uncertainty-aware Exploration combining epistemic and aleatory uncertainty",
      authors: "P Malekzadeh, M Hou, KN Plataniotis",
      venue: "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), 2023",
      image: process.env.PUBLIC_URL + "/images/Uncertainty.jpg",
      links: [
        { label: "paper", url: "https://arxiv.org/pdf/2401.02914.pdf" },
        { label: "webpage", url: process.env.PUBLIC_URL + "/assets/UUaE/index.html" }
      ]
    },
    {
      title: "MM-KTD: Multiple Model Kalman Temporal Differences for reinforcement learning",
      authors: "P Malekzadeh, M Salimibeni, A Mohammadi, A Assa, KN Plataniotis",
      venue: "IEEE Access, 2020",
      image: process.env.PUBLIC_URL + "/images/MM-KTD.jpg",
      links: [
        { label: "paper", url: "https://ieeexplore.ieee.org/stamp/stamp.jsp?arnumber=9136644" },
        { label: "code", url: "https://github.com/pmalekzadeh/MM-KTD" }
      ]
    },
    {
      title: "MAKF-SR: Multi-Agent adaptive Kalman Filtering-based Successor Representations",
      authors: "M Salimibeni, P Malekzadeh, A Mohammadi, P Spachos, KN Plataniotis",
      venue: "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), 2021",
      links: []
    },
    {
      title: "Non-Gaussian BLE-Based Indoor Localization Via Gaussian Sum Filtering Coupled with Wasserstein Distance",
      authors: "P Malekzadeh, S Mehryar, P Spachos, KN Plataniotis, A Mohammadi",
      venue: "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), 2020",
      links: []
    },
    {
      title: "STUPEFY: Set-Valued Box Particle Filtering for Bluetooth Low Energy-Based Indoor Localization",
      authors: "P Malekzadeh, A Mohammadi, M Barbulescu, KN Plataniotis",
      venue: "IEEE Signal Processing Letters, 2019",
      links: []
    }
  ],
  timeline: [
    // {
    //   date: "2024–Present",
    //   title: "Postdoctoral Fellow in Operations Management and Statistics",
    //   org: "Rotman School of Management, University of Toronto",
    //   location: "Toronto, Canada",
    //   logo: process.env.PUBLIC_URL + "/images/rotman.png"
    // },
    {
      date: "2020–2024",
      title: "Ph.D. in Electrical and Computer Engineering",
      org: "University of Toronto",
      location: "Toronto, Canada",
      logo: process.env.PUBLIC_URL + "/images/uoft.png"
    },
    {
      date: "2018–2020",
      title: "M.Sc. in Electrical and Computer Engineering",
      org: "Concordia University",
      location: "Montreal, Canada",
      logo: process.env.PUBLIC_URL + "/images/concordia.png"
    },
    {
      date: "2013–2018",
      title: "B.Sc. in Electrical and Computer Engineering",
      org: "Sharif University of Technology",
      location: "Tehran, Iran",
      logo: process.env.PUBLIC_URL + "/images/sharif.png"
    }
  ],
  experience: [
    {
      title: "AI Researcher",
      organization: "SiMLQ",
      location: "Toronto, Canada",
      period: "Oct. 2024 - Present",
      description: "Developing machine learning and AI algorithms for optimizing and automating patient flow in emergency departments."
    },
    {
      title: "AI Researcher – LLM",
      organization: "Extropolis AI",
      location: "Remote",
      period: "June 2022 - Oct. 2024",
      description: "Designed LLM-based agents for reasoning and workflow automation."
    },
    {
      title: "AI Researcher",
      organization: "Rotman's FinHub",
      location: "Toronto, Canada",
      period: "May 2023 - Aug. 2024",
      description: "Developed reinforcement learning algorithms for financial market hedging."
    },
    {
      title: "AI Researcher",
      organization: "Dormakaba",
      location: "Montreal, Canada",
      period: "Jan. 2019 - Jan. 2021",
      description: "Conducted literature reviews and developed machine learning models to enhance the security of electronic access systems using mobile Bluetooth signals."
    }
  ],
  teaching: {
    instructor: [
      {
        period: "Spring 2027 (scheduled)",
        organization: "University of Toronto",
        courses: [
          {
            title: "Data Science for Managers (MBA)",
            location: "Rotman School of Management, University of Toronto"
          }
        ]
      },
      {
        period: "Fall 2026",
        organization: "York University",
        courses: [
          {
            title: "Business Applications of Artificial Intelligence I (Master of Management in Artificial Intelligence)",
            location: "Schulich School of Business, York University"
          }
        ]
      },
      {
        period: "Winter 2026",
        organization: "University of Toronto",
        courses: [
          {
            title: "Reinforcement Learning",
            location: "Rotman School of Management, University of Toronto"
          }
        ]
      },
      {
        period: "Winter 2026",
        organization: "York University",
        courses: [
          {
            title: "Predictive Analytics",
            location: "Schulich School of Business, York University"
          }
        ]
      },
      {
        period: "Summer 2023",
        organization: "Queen's College of Business, Technology & Public Safety",
        courses: [
          {
            title: "Python Coding"
          }
        ]
      }
    ]
  },
  seminars: [
    {
      year: "2026",
      month: null,
      title: "A Unified Particle Filter LSTM for Data-Driven Process Simulation",
      conferences: [
        "INFORMS Workshop on Data Science (accepted)."
      ]
    },
    {
      year: "2026",
      month: null,
      title: "Sample-Augmented Reinforcement Learning for Event-Driven Queueing Control",
      conferences: [
        "2026 Annual Conference of the Canadian Operational Research Society (CORS), Kingston, Canada.",
        "2026 Artificial Intelligence and Machine Learning in Operations Management Research (AIMOR), Calgary, Canada."
      ]
    },
    {
      year: "2025",
      month: null,
      title: "Shift Effect in Physician Effort Allocation in Emergency Departments with Patient Abandonment",
      conferences: [
        "2025 Annual Canadian Celebration of Women in Computing (CAN-CWiC), Toronto, Canada.",
        "2025 INFORMS Annual Meeting, Atlanta, USA.",
        "2025 CanQueue Workshop, London, Canada.",
        "2025 INFORMS Computing Society Conference (ICS), Toronto, Canada."
      ]
    },
    {
      year: "2025",
      month: "Oct.",
      title: "Reinforcement Learning in Action: From Games to Operational Research",
      conferences: [
        "3rd year Engineering Science Seminar course, University of Toronto"
      ]
    },
    {
      year: "2025",
      month: "Jun.",
      title: "Shift Effects in the Emergency Department: Threshold Routing and Tail Access Performance",
      conferences: [
        "66th Annual Conference of the Canadian Operational Research Society (CORS), Edmonton, Canada",
        "8th Annual Research Roundtable: Data Analytics in Healthcare, Toronto, Canada"
      ]
    },
    {
      year: "2024",
      month: "July",
      title: "Active Inference and Reinforcement Learning: A Unified Inference on Continuous State and Action Spaces under Partial Observability",
      conferences: [
        "CIFAR Deep Learning + Reinforcement Learning (DLRL) Summer School, Toronto, Canada"
      ]
    },
    {
      year: "2024",
      month: "Apr.",
      title: "A Robust Quantile Huber Loss With Interpretable Parameter Adjustment in Distributional Reinforcement Learning",
      conferences: [
        "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), Seoul, Korea"
      ]
    },
    {
      year: "2023",
      month: "June",
      title: "UUaE: A Unified Uncertainty-aware Exploration combining Epistemic and Aleatory Uncertainty",
      conferences: [
        "IEEE International Conference on Acoustics, Speech and Signal Processing (ICASSP), Virtual"
      ]
    }
  ]
};

export default profile; 